<template>
  <confirmation-dialog
    value="true"
    :onConfirmed="onConfirmed"
    :onCancelled="onCancelled">
    <h3>{{ $t('site-administration.topology-change.confirmation.header') }}</h3>
    <p>{{ $t('site-administration.topology-change.confirmation.paragraph-1') }}</p>
    <p>{{ $t('site-administration.topology-change.confirmation.paragraph-2') }}</p>
  </confirmation-dialog>
</template>

<script>
import ConfirmationDialog from '@/components/confirmation-dialog'

export default {
  name: 'site-topology-change-confirmation',
  components: {
    ConfirmationDialog
  },
  props: {
    onConfirmed: { type: Function, required: true },
    onCancelled: { type: Function, required: true }
  }
}
</script>
